import React, { useState } from 'react';
import { _ as _taggedTemplateLiteralLoose } from './taggedTemplateLiteralLoose-7a042257.esm.js';
import { textSizes } from '@growth/design-system';
import styled from 'styled-components';

var _templateObject$2, _templateObject2$2, _templateObject3$1, _templateObject4$1;
var SearchItem$1 = styled.li(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-shrink: 0;\n\tjustify-content: space-between;\n\talign-items: center;\n\tcursor: pointer;\n\tmargin-top: ", ";\n\tmargin-bottom: ", ";\n\theight: ", ";\n\tbackground: ", ";\n\n\t&:hover {\n\t\tbackground: #eef4fd;\n\t}\n"])), function (_ref) {
  var isMWeb = _ref.isMWeb;
  return isMWeb ? '16px' : '12px';
}, function (_ref2) {
  var isMWeb = _ref2.isMWeb;
  return isMWeb ? '16px' : '12px';
}, function (_ref3) {
  var isMWeb = _ref3.isMWeb;
  return isMWeb ? '32px' : '44px';
}, function (_ref4) {
  var isSelected = _ref4.isSelected;
  return isSelected ? '#eef4fd' : 'transparent';
});
var LocationWrapper = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n"])));
var IconWrapper = styled.span(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n\tbackground: #f4f4f4;\n\tborder-radius: 4px;\n\twidth: ", ";\n\theight: ", ";\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-right: 12px;\n"])), function (_ref5) {
  var isMWeb = _ref5.isMWeb;
  return isMWeb ? '32px' : '44px';
}, function (_ref6) {
  var isMWeb = _ref6.isMWeb;
  return isMWeb ? '32px' : '44px';
});
var LocationName = styled.span(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #222222;\n\tline-height: 19px;\n"])), textSizes.MediumW1);

var SearchItem = function SearchItem(_ref) {
  var id = _ref.id,
    icon = _ref.icon,
    name = _ref.name,
    itemClickHandler = _ref.itemClickHandler,
    isSelected = _ref.isSelected,
    isMWeb = _ref.isMWeb,
    className = _ref.className,
    countryCode = _ref.countryCode,
    countryName = _ref.countryName;
  return /*#__PURE__*/React.createElement(SearchItem$1, {
    className: className,
    isMWeb: isMWeb,
    isSelected: isSelected,
    onClick: function onClick() {
      return itemClickHandler({
        id: id,
        name: name,
        countryCode: countryCode,
        countryName: countryName
      });
    }
  }, /*#__PURE__*/React.createElement(LocationWrapper, null, /*#__PURE__*/React.createElement(IconWrapper, {
    isMWeb: isMWeb
  }, icon), /*#__PURE__*/React.createElement(LocationName, null, name)));
};
SearchItem.defaultProps = {
  isSelected: false,
  className: ''
};

var _templateObject$1, _templateObject2$1, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var SearchBoxContainer = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\tpadding: 16px;\n"])));
var SearchResultContainer = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n\tbackground-color: ", ";\n\tpadding: ", ";\n"])), function (prop) {
  return prop.isMWeb ? '#f4f4f4;' : '#ffffff';
}, function (prop) {
  return prop.isMWeb ? '0 16px 16px' : '0 16px 16px 16px';
});
var SearchResultListContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tpadding: ", ";\n\tborder-radius: ", ";\n\tbackground-color: #ffffff;\n\n\t& .firstItem {\n\t\tmargin-top: 0;\n\t}\n\n\t& .lastItem {\n\t\tmargin-bottom: 0;\n\t}\n"])), function (prop) {
  return prop.isMWeb ? '12px' : '0';
}, function (prop) {
  return prop.isMWeb ? '4px' : '0';
});
styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 22px;\n\tbackground-repeat: no-repeat;\n\theight: 18px;\n\tbackground-image: url(\"data:image/svg+xml,%0A%3Csvg width='18' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.636 2.637a9.005 9.005 0 0 1 12.73-.004 9.013 9.013 0 0 1 0 12.734 9.005 9.005 0 0 1-12.73-.004 8.998 8.998 0 0 1 0-12.726Zm9.867 9.854a.75.75 0 0 0 .027-1.03l-2.335-2.334a.188.188 0 0 1 0-.264l2.335-2.334a.75.75 0 1 0-1.062-1.062L9.134 7.801a.188.188 0 0 1-.266 0L6.534 5.467A.75.75 0 0 0 5.476 6.53L7.81 8.863a.187.187 0 0 1 0 .264L5.476 11.46a.75.75 0 0 0 0 1.062.765.765 0 0 0 1.062 0l2.334-2.334a.19.19 0 0 1 .266 0l2.334 2.334a.75.75 0 0 0 1.031-.03Z' fill='%23777'/%3E%3C/svg%3E\");\n"])));
var MapIcon = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\twidth: 14px;\n\tbackground-repeat: no-repeat;\n\theight: 18px;\n\tbackground-image: url(\"data:image/svg+xml,%0A%3Csvg width='14' height='18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 6.923A6.93 6.93 0 0 1 6.923 0a6.931 6.931 0 0 1 6.922 6.923c0 4.39-6.17 10.61-6.432 10.874a.692.692 0 0 1-.98 0C6.17 17.534 0 11.313 0 6.923Zm4.499 0a2.423 2.423 0 1 0 4.846 0 2.423 2.423 0 0 0-4.846 0Z' fill='%23647A97'/%3E%3C/svg%3E\");\n"])));
var HorizontalLine = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n\t\theight: 1px;\n\t\tbackground-color: #e4e4e4;\n\t\tmargin: ", ";\n"])), function (prop) {
  return prop.gapping || "0";
});
var SearchResultHeading = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #717171;\n\tpadding: 16px 0;\n"])), textSizes.BaseW2);
var NoResultFound = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n\t", "\n\tcolor: #717171;\n\tpadding: 20px 0 12px 0px;\n\ttext-align: center;\n"])), textSizes.BaseW2);

var SearchIcon = function SearchIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "#B0B0B0",
    height: "1.6rem",
    width: "1.6rem",
    className: "HappySearchIcon-sc-9cg8c3-0 kWKCFW"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.61 13.731-3.095-3.096a6.84 6.84 0 0 0-1.348-9.084 6.83 6.83 0 0 0-9.166.452 6.84 6.84 0 0 0-.449 9.172 6.83 6.83 0 0 0 9.079 1.346l3.095 3.095c.524.512 1.36.512 1.884 0 .52-.52.52-1.364 0-1.885M6.84 2.008a4.83 4.83 0 0 1 4.83 4.833 4.831 4.831 0 1 1-9.661 0 4.837 4.837 0 0 1 4.83-4.833z"
  }));
};

var _templateObject, _templateObject2;
var StyledInputFieldContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n\tpadding: 14px;\n  border-radius: 4px;\n  border: solid 1px;\n  background-color: #fff;\n\tborder-color: ", ";\n\n"])), function (props) {
  return props.hasFocus ? '#2276e3' : '#e4e4e4';
});
var StyledInput = styled.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\tbox-sizing: border-box;\n\tfont-family: Rubik;\n\t", ";\n\tborder: none;\n\tcolor: #222;\n\tpadding-right: 8px;\n\theight: 26px;\n\n\t&:focus {\n\t\toutline: none;\n\t}\n\n\t&::placeholder {\n\t\tcolor: #717171;\n\t\theight: 17px;\n\t\t", ";\n\t}\n"])), textSizes.BaseW2, textSizes.BaseW1);

function InputField(props) {
  var inputName = props.inputName,
    inputClassName = props.inputClassName,
    onChange = props.onChange,
    inputType = props.inputType,
    maxlength = props.maxlength,
    autoFocus = props.autoFocus,
    placeholder = props.placeholder,
    inputVal = props.inputVal,
    inputDisabled = props.inputDisabled,
    Icon = props.rightIconComp,
    showIcon = props.showIcon;
  var _useState = useState(inputVal),
    value = _useState[0],
    setValue = _useState[1];
  var _useState2 = useState(false),
    hasFocus = _useState2[0],
    setHasFocus = _useState2[1];
  var handleInputChange = function handleInputChange(e) {
    setValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  };
  return /*#__PURE__*/React.createElement(StyledInputFieldContainer, {
    hasFocus: hasFocus
  }, /*#__PURE__*/React.createElement(StyledInput, {
    className: inputClassName,
    onChange: handleInputChange,
    type: inputType,
    maxLength: maxlength,
    name: inputName,
    autoFocus: autoFocus,
    placeholder: placeholder,
    value: value,
    disabled: inputDisabled,
    onFocus: function onFocus() {
      return setHasFocus(true);
    },
    onBlur: function onBlur() {
      return setHasFocus(false);
    }
  }), !value && showIcon && Icon && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, null)));
}
InputField.defaultProps = {
  inputName: '',
  inputClassName: '',
  onChange: function onChange() {},
  inputType: 'text',
  maxlength: 255,
  autoFocus: true,
  placeholder: 'Enter text',
  inputVal: '',
  inputDisabled: false,
  rightIconComp: SearchIcon,
  showIcon: true
};

function SearchResultMenu(props) {
  var options = props.options,
    _props$selectedID = props.selectedID,
    selectedID = _props$selectedID === void 0 ? '' : _props$selectedID,
    handleOptionSelected = props.handleOptionSelected,
    handleSearch = props.handleSearch,
    _props$isMWeb = props.isMWeb,
    isMWeb = _props$isMWeb === void 0 ? false : _props$isMWeb,
    inputPlaceholder = props.inputPlaceholder,
    selectedValue = props.selectedValue,
    error = props.error;
  var getClassName = function getClassName(index, length) {
    if (index === 0) {
      return 'firstItem';
    }
    if (index === length - 1) {
      return 'lastItem';
    }
    return '';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchBoxContainer, null, /*#__PURE__*/React.createElement(InputField, {
    onChange: function onChange(e) {
      return handleSearch(e.target.value);
    },
    placeholder: inputPlaceholder,
    inputVal: selectedValue
  })), !isMWeb && /*#__PURE__*/React.createElement(HorizontalLine, {
    gapping: "0 16px"
  }), /*#__PURE__*/React.createElement(SearchResultContainer, {
    isMWeb: isMWeb
  }, (options == null ? void 0 : options.length) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchResultHeading, null, "SEARCH RESULTS"), /*#__PURE__*/React.createElement(SearchResultListContainer, {
    isMWeb: isMWeb
  }, options.map(function (item, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchItem, {
      itemClickHandler: function itemClickHandler(selectedOption) {
        return handleOptionSelected(selectedOption);
      },
      icon: /*#__PURE__*/React.createElement(MapIcon, null),
      key: item.id,
      id: item.id,
      name: item.name,
      countryCode: item.countryCode,
      countryName: item.countryName,
      isSelected: selectedID === item.id,
      isMWeb: isMWeb,
      className: getClassName(index, options.length)
    }), isMWeb && index < options.length - 1 && /*#__PURE__*/React.createElement(HorizontalLine, null));
  }))) : /*#__PURE__*/React.createElement(NoResultFound, null, error || "Sorry, No results found")));
}
SearchResultMenu.defaultProps = {
  isMWeb: false,
  selectedValue: '',
  error: undefined
};

export { SearchResultMenu as S };
